import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Container, Banner, Typeahead, TimePicker,
    cellEditFactory, Type, moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, sizePerPageRenderer
} 
from '../../noser-hris-component';
import CreateDepartment from './Modal/CreateDepartment';


class Department extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userinfo        :   [],
            isloading       :   false,
            isshow          :   false,
            alerttype       :   "",
            message         :   "",
            color           :   "",
            fade            :   true,

            departmentCodeAutocomplete      :   [],
            nameDDL         :   [],
            departmentList                  :   [],
            newDepartmentList               :   [],
            selectedDepartmentCode          :   '',
            selectedDescription             :   '',
            selectedCostCenter              :"",
            selectedCostCenterId            :"",
        }
    }
    componentDidMount(){
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.GetDepartment();
    }
    GetDepartment() {
        const departmentCodeParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "Name"          :   "",
        };

        axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetDepartments",  departmentCodeParams)
        .then(res => {
            const data = res.data;
            console.log("Get Departments Code");
            console.log(data);
            this.setState({
                nameDDL  :   data.departments,
                departmentList  :   data.departments,
            });
         })
    }
    handleModalShow = (e) =>{
        this.setState({openModal:true})
        let obj = {}
        this.child.initialize(obj)
    }
    handleModalClose = (e) =>{
        this.setState({openModal:false})
        this.GetDepartment()
    }

    

    handleDescription = (e) => {
        console.log(e)
            if (e.length > 0) {
            this.state.name = e[0].name
        } else {
            this.state.name = ""
        }
    }

    handleSearchClick = event => {
        this.setState({isloading:true})

        const areaSearchParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "Name"          :   this.state.name,
        };

        console.log("Submit Search Params")
        console.log(areaSearchParams)

        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetDepartments",  areaSearchParams)
            .then(res => {
                const data = res.data;
                console.log("Get Department List")
                console.log(data)
                this.setState({
                    departmentList  :   data.departments,
                    isloading       :   false,
                })
                if(data.status==="0"){
                    this.setState({
                        isloading   :   false,
                        alerttype   :   "Error!",
                        isshow      :   true,
                        color       :   "danger",
                        message     :   data.message,
                        fade        :   true
                    });
                }
            })
            .catch(error=>{
                this.setState({
                    isloading       :   false,
                    alerttype       :   "Error!",
                    isshow          :   true,
                    color           :   "danger",
                    message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    fade            :   true
                })
            })

    }

    handleSaveClick = event => {
        this.setState({
            isloading           :   true
        })
        const editDepartmentParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "Departments"   :   this.state.departmentList.filter(x=>x.isModified==="1" || x.isDeleted==="1"),
        };

        console.log("Submit Edit Params")
        console.log(editDepartmentParams)

        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/EditDepartment", editDepartmentParams)
            .then(res => {
                const data = res.data;
                
                if(data.status=="1"){
                    this.handleSearchClick()
                }
                else{
                    this.setState({
                        isloading   :   false,
                        alerttype   :   "Error!",
                        isshow      :   true,
                        color       :   "danger",
                        message     :   data.message,
                        fade        :   true
                    })
                }
             })
             .catch(error=>{
                this.setState(  {
                    isloading   :   false,
                    alerttype   :   "Error!",
                    isshow      :   true,
                    color       :   "danger",
                    message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    fade        :   true
                })
            })
    }


    refreshPage(){
        this.setState({isloading:true})

        const areaSearchParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "Code"          :   "",
            "Name"          :   "",
            "CostCenterId"    :   "",
        };
        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetDepartments",  areaSearchParams)
            .then(res => {
                const data = res.data;
                this.setState({
                    departmentList  :   data.departments,
                    isloading       :   false,
                })
                if(data.status==="0"){
                    this.setState({
                        isloading   :   false,
                        alerttype   :   "Error!",
                        isshow      :   true,
                        color       :   "danger",
                        message     :   data.message,
                        fade        :   true
                    });
                }
            })
            .catch(error=>{
                this.setState({
                    isloading       :   false,
                    alerttype       :   "Error!",
                    isshow          :   true,
                    color           :   "danger",
                    message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    fade            :   true
                })
            })
    }

    GridDataModified(oldValue, newValue, rowid, column) {
        let isDisable = true
        this.state.departmentList.map(function(item,i){
            if(item.id==rowid)
                item.isModified = "1"
            if(item.isModified=="1")
                isDisable = false
            ////console.log(isDisable)
        })
        this.setState({disableSaveBtn:isDisable})
    }

    render() {
        const columnDepartment = [
            {
                dataField   : 'name',
                text        : 'Name',
                editable:true,
                headerStyle : () => {
                    return { width  : "50%" };
                  }
            },
            {
                dataField   : 'costCenter',
                text        : 'Cost Center',
                editable:true,
                headerStyle : () => {
                    return { width  : "50%" };
                  }
            },
        ]

        const selectRow = {
            mode: 'checkbox',
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                this.state.departmentList.map(function(item,i){
                    if(item.id===row.id)
                    {
                        item.isDeleted = isSelect ? "1" : "0"
                        //item.isModified = isSelect ? "1" : "0"
                    }
                })
            }
        };

        const rowEvents = {
            onClick: (e, row, rowIndex) => {
            }
        };


    return(
            <div>
                <Banner />
                <Container className="themed-container" fluid={true}>
                    <Card className="mt-5">
                        <Card.Header className='login-card'>MAINTENANCE &gt;&gt; COST CTR &gt;&gt; Department</Card.Header>
                        <Card.Body>
                            <div>
                                <Form>
                                    <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                                        <div className={this.state.color}></div> 
                                        {this.state.message}
                                    </Alert>
                                    <Form.Group as={Row} controlId="formHorizontalEmail">
                                        <Form.Label column sm="1" style={{fontWeight : "bold"}}>
                                            NAME
                                        </Form.Label>
                                        <Col >
                                            <Typeahead
                                                labelKey='name'
                                                id="basic-example"
                                                onChange={this.handleDescription}
                                                options={this.state.nameDDL}
                                                placeholder="Select Name"
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formHorizontalEmail">
                                        <Col >
                                        <ButtonToolbar >
                                            <Button variant="primary" className="ml-auto noser-button-mr1" onClick={this.handleSearchClick}>Search</Button>
                                        </ButtonToolbar>
                                        </Col>
                                    </Form.Group>
                                    <div className="mt-1">
                                    <Card.Header>LIST OF DEPARMENTS</Card.Header>
                                        <BootstrapTable
                                            /* caption={Noser.TableHeader({title:"RECORD"})} */
                                            keyField = "id"
                                            data = { this.state.departmentList }
                                            columns = { columnDepartment }
                                            pagination={ paginationFactory({sizePerPageRenderer}) }
                                            rowClasses="noser-table-row-class"
                                            striped
                                            hover
                                            condensed
                                            cellEdit = { cellEditFactory({
                                                mode: 'dbclick',
                                                blurToSave: true,
                                                afterSaveCell: (oldValue, newValue, row, column) => {
                                                    this.GridDataModified(oldValue, newValue, row.id, column.dataField)
                                                    }
                                                })
                                            }
                                            rowEvents={ rowEvents }
                                            selectRow = { selectRow }
                                            noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                        />
                                        <Form.Group as={Row} controlId="formHorizontalEmail">
                                        <Col>
                                        <ButtonToolbar sm={12}>
                                            <Button variant="success" className="ml-auto noser-button-mr1" onClick = { this.handleSaveClick }>Save</Button>
                                            <Button variant="primary" className="noser-button" onClick = { this.handleModalShow }>Create</Button>
                                        </ButtonToolbar>
                                        </Col>
                                        </Form.Group>
                                    </div>
                                </Form>
                            </div>
                        </Card.Body>
                    </Card>
                </Container>
                <NoserLoading show={this.state.isloading} />
                <CreateDepartment
                    show={this.state.openModal}
                    onHide={this.handleModalClose}
                    onRefModal={ref => (this.child = ref)}
                />
            </div> 
        )
    }

}

export  default Department 